import React from "react";
import PhoneInput from "react-phone-input-2";
import GlobalErrorMsgBox from "./GlobalErrorMsgBox";
import "react-phone-input-2/lib/style.css";
import style from "../../assets/css/global-fields.module.scss";

const GlobalPhoneInput = ({
  id,
  name,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  cssClass = "",
  disabled = false,
  containerStyle = {},
  dropdownStyle = {},
}) => {
  return (
    <div className={style.phoneInputMain}>
      <PhoneInput
        country={"us"}
        className={cssClass}
        value={value}
        onChange={(value, countryDetails, e, formattedVal) => {
          onChange({
            value,
            countryDetails,
            formattedVal,
          });
        }}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={""}
        // renderStringAsFlag=" "
        copyNumbersOnly
        // enableAreaCodes
        dropdownStyle={dropdownStyle}
        containerStyle={containerStyle}
        inputProps={{
          name,
          id,
          "aria-label": "Phone number input", // <-- this line adds screen reader support
        }}
      />
      {error ? <GlobalErrorMsgBox errMessage={helperText} /> : null}
    </div>
  );
};

export default GlobalPhoneInput;
